import { i18nObject } from 'boot/i18n'
import { captureEvent, captureException, captureMessage } from 'src/common/sentry-client'
import { notification } from 'src/core/hooks/notifications'

export function consoleLogAPI(error) {
  const isNetworkError = !!error.networkError
  const isGraphQlError = !!error.graphQLErrors
  const isApiError = error.name === 'AxiosError'

  if (isNetworkError || isGraphQlError || isApiError) {
    return
  }

  console.error(error)
  captureException(error)
}

export function parseApiError(e) {
  const t = i18nObject.global.t
  const appendErrorValue = (container, value) => {
    if (value === null || value === undefined) {
      return
    }

    if (Array.isArray(value)) {
      value.forEach((item) => appendErrorValue(container, item))
      return
    }

    if (typeof value === 'object') {
      Object.values(value).forEach((item) => appendErrorValue(container, item))
      return
    }

    container.push(String(value))
  }

  if (!e) {
    return t('unexpected_error_try_again')
  }

  if (!e.response) {
    return t('networkErrorTryAgain')
  }

  if (e.response && e.response.data) {
    const errorBody = e.response.data

    if (e.response.status >= 500 || e.toString().includes('timeout of')) {
      return t('serverErrorTryAgain')
    }

    if (errorBody.non_field_errors) {
      return t('ValidationErrorsInFiedls') + ': ' + errorBody.non_field_errors.join(', ')
    }

    if (errorBody.detail) {
      return errorBody.detail
    }

    if (Object.keys(errorBody).length) {
      const errorsArr = []

      Object.entries(errorBody).forEach(([_, value]) => {
        appendErrorValue(errorsArr, value)
      })

      if (errorsArr.length) {
        return errorsArr.join(' ')
      }
    }
  }

  return t('unexpected_error_try_again')
}

export function showErrorNotification(parsedError) {
  if (!parsedError) {
    notification({ type: 'warning', text: i18nObject.global.t('unexpected_error_try_again') })
    return
  }

  notification({ type: 'warning', text: parsedError })
}

export function checkContextErrors(error) {
  if (error && error.response?.data) {
    if (Object.keys(error.response.data).length) {
      return error.response.data
    }
  }
  return []
}

export const sendDebugInfoToSentry = (message, data = {}, level = 'debug') => {
  try {
    captureMessage(message, {
      extras: data?.extras ?? {},
      tags: data?.tags ?? {},
      level,
    })
  } catch (e) {
    console.error(e)
  }
}

export function captureCustomEvent(eventType, details) {
  captureEvent({
    message: eventType,
    level: 'info',
    tags: {
      eventType: eventType,
    },
    extra: details,
  })
}

export const loggingWebview = (type, user_id) => {
  const initPath = localStorage.getItem('wv-init-href')

  sendDebugInfoToSentry('Mobile Webview Auth Event', {
    extras: {
      initPath: initPath,
      currentPath: location.href,
    },
    tags: {
      webview: type,
      hostname: location.hostname,
      user_id: user_id || 'none',
    },
  })
}
